<script setup>
import BaseModal from "@/components/global-themed/BaseModal.vue";
import FixPanelIcon from "@/components/approval-center/partials/ui/FixPanelIcon.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import ModalContentWrapper from "@/components/global-themed/ui/modals/ModalContentWrapper.vue";
import KitModalHeader from "@/components/global-themed/ui/modals/KitModalHeader.vue";
import ModalTextAreaWrapper from "@/components/global-themed/ui/modals/ModalTextAreaWrapper.vue";
import KitIcon from "@/components/approval-center/partials/kit/KitIcon.vue";
import DidYouKnowBanner from "@/components/approval-center/partials/DidYouKnowBanner.vue";

const defaultPlaceholder = `For example:
\t•\t“Remove the word ‘free’.”
\t•\t“Make it sound more conversational and friendly.”
\t•\t“Can you rewrite this to feel more confident?”
\t•\t“Add a stronger call to action at the end.”
\t•\t“Shorten it so it fits better in search results.”
\t•\t“Completely rephrase this in a more professional tone.”
\t•\t“Make it a bit funnier or more lighthearted.”`;

defineProps({
  kitIconState: {
    type: String,
    default: 'default',
    validator: (value) => [
      'default',
      'success',
      'error',
      'thinking',
      'wink',
      'sad',
    ].includes(value)
  },
  placeholder: {
    type: [String, null],
    default: null,
  },
  errors: {
    type: Object,
    default: () => ({})
  }
});

const feedbackValue = defineModel({
  type: String,
  required: true,
});


const emit = defineEmits(['close', 'confirm', 'extra-help']);
</script>

<template>
  <Teleport
    to=".tailwind"
  >
    <BaseModal
      modal-class="tw-w-[800px]"
      @close="emit('close')"
    >
      <ModalContentWrapper>
        <KitModalHeader>
          <KitIcon
            class="tw-w-[88px]"
            :state="kitIconState"
          />

          <slot name="header" />
        </KitModalHeader>

        <DidYouKnowBanner />

        <div class="tw-flex tw-flex-col tw-gap-6">
          <span class="tw-flex tw-gap-3 tw-text-neutral-900 tw-font-bold tw-text-2xl tw-leading-none">
            <FixPanelIcon icon-path="icons/users-talking" />
            <slot name="feedbackTitle">
              Tell me what to tweak or improve 👇
            </slot>
          </span>

          <ModalTextAreaWrapper :error="!!errors.feedback">
            <div>
              <textarea
                v-model="feedbackValue"
                :placeholder="placeholder ?? defaultPlaceholder"
                autofocus
                rows="8"
                class="tw-w-full tw-text-neutral-900 tw-text-base tw-resize-none"
              />
              <p
                v-if="errors.feedback"
                class="tw-text-danger"
              >
                {{ errors.feedback[0] }}
              </p>
            </div>
          </ModalTextAreaWrapper>
        </div>

        <div class="tw-flex tw-items-center tw-gap-4 tw-self-end">
          <DefaultButton
            variant="primary-inverted"
            @click="emit('close')"
          >
            Cancel
          </DefaultButton>
          <DefaultButton @click="emit('confirm')">
            Continue
          </DefaultButton>
        </div>
      </ModalContentWrapper>
    </BaseModal>
  </Teleport>
</template>
